import {createRouter, createWebHistory} from 'vue-router'
import store from "@/store"

const routes = [
    {
        path: "/auth",
        component: () => import("../views/Auth")
    },
    {
        path: "/",
        component: () => import("../views/Home.vue"),
        meta: {
            load: () => {
                if (!localStorage.token || !localStorage.refresh_token) {
                    return "/auth"
                }
                store.dispatch("loadData")
            }
        }
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    let nextPath = null
    if (to.meta.load) {
        nextPath = to.meta.load(to, from, next)
    }
    if (nextPath) {
        next(nextPath)
    } else {
        next()
    }
})

export default router
